module.exports = __webpack_public_path__ + "images/bitmap-29a703e7.jpg";